import {NavigationGuard} from 'vue-router';
import {isAuthenticated, hasRole, RoleType} from './authentication-functions';

export const guards: NavigationGuard = (to, from, next) => {

	const authenticated = isAuthenticated();

	if (to.meta.anonymous !== true) {

		if (authenticated) {

			next();

		} else {

			next({name: 'Sign In', query: {redirect: to.fullPath}});
		}

	} else if (authenticated) {

		const redirectUrl = Array.isArray(to.query.redirect) ? to.query.redirect[0] : to.query.redirect;

		if (redirectUrl) {

			next(redirectUrl);

		}
		else if (to.meta?.anonymousOnly === false) {

			next();

		} else {

			next({name: 'Home'});
		}

	} else {

		next();
	}
};

export const withRoleGuard: (...roles: RoleType[]) => NavigationGuard = (...roles) => (to, from, next) => {
	if(!roles.some(r => hasRole(r))) {
		next(false);
		return;
	}

	next();
};